import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteNodeWithLinkGuardMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  node: Types.Scalars['String'];
  linkedAction?: Types.InputMaybe<Types.LinkedNodeDeleteAction>;
}>;


export type DeleteNodeWithLinkGuardMutation = { deleteNode?: { code: string, message: string, success: boolean, choiceRequired?: boolean | null, linkedNodesTotal?: number | null, deletedNodesTotal?: number | null, linkedNodeGroups?: Array<{ hierarchyId: string, hierarchyCode: string, objectSchemaCode: string, totalCount: number, items: Array<{ nodeId: string, code: string, listName?: string | null, parent?: string | null, hierarchyId: string, hierarchyCode: string, linkedByFields?: Array<string> | null }> }> | null } | null };

export type DeleteHierarchyWithLinkGuardMutationVariables = Types.Exact<{
  aggregateId: Types.Scalars['String'];
  linkedAction?: Types.InputMaybe<Types.LinkedNodeDeleteAction>;
}>;


export type DeleteHierarchyWithLinkGuardMutation = { deleteHierarchy?: { code: string, message: string, success: boolean, choiceRequired?: boolean | null, linkedNodesTotal?: number | null, deletedNodesTotal?: number | null, linkedNodeGroups?: Array<{ hierarchyId: string, hierarchyCode: string, objectSchemaCode: string, totalCount: number, items: Array<{ nodeId: string, code: string, listName?: string | null, parent?: string | null, hierarchyId: string, hierarchyCode: string, linkedByFields?: Array<string> | null }> }> | null } | null };

export type LinkedNodesForDeleteQueryVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  linkingHierarchyId?: Types.InputMaybe<Types.Scalars['String']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type LinkedNodesForDeleteQuery = { getLinkedNodesForDelete: { total: number, groups: Array<{ hierarchyId: string, hierarchyCode: string, objectSchemaCode: string, totalCount: number, items: Array<{ nodeId: string, code: string, listName?: string | null, parent?: string | null, hierarchyId: string, hierarchyCode: string, linkedByFields?: Array<string> | null }> }> } };

export type CascadeDeletePreviewQueryVariables = Types.Exact<{
  hierarchyId: Types.Scalars['String'];
  nodeId: Types.Scalars['String'];
  linkingHierarchyId?: Types.InputMaybe<Types.Scalars['String']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type CascadeDeletePreviewQuery = { getCascadeDeletePreview: { total: number, capExceeded: boolean, lockedNodes: Array<{ hierarchyId: string, nodeId: string, code: string, message?: string | null }>, groups: Array<{ hierarchyId: string, hierarchyCode: string, objectSchemaCode: string, totalCount: number, items: Array<{ nodeId: string, code: string, listName?: string | null, parent?: string | null, hierarchyId: string, hierarchyCode: string, reason: Types.CascadeDeleteReason, viaCode?: string | null }> }> } };


export const DeleteNodeWithLinkGuardDocument = gql`
    mutation DeleteNodeWithLinkGuard($aggregateId: String!, $node: String!, $linkedAction: LinkedNodeDeleteAction) {
  deleteNode(aggregateId: $aggregateId, node: $node, linkedAction: $linkedAction) {
    code
    message
    success
    choiceRequired
    linkedNodesTotal
    deletedNodesTotal
    linkedNodeGroups {
      hierarchyId
      hierarchyCode
      objectSchemaCode
      totalCount
      items {
        nodeId
        code
        listName
        parent
        hierarchyId
        hierarchyCode
        linkedByFields
      }
    }
  }
}
    `;
export type DeleteNodeWithLinkGuardMutationFn = Apollo.MutationFunction<DeleteNodeWithLinkGuardMutation, DeleteNodeWithLinkGuardMutationVariables>;

/**
 * __useDeleteNodeWithLinkGuardMutation__
 *
 * To run a mutation, you first call `useDeleteNodeWithLinkGuardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNodeWithLinkGuardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNodeWithLinkGuardMutation, { data, loading, error }] = useDeleteNodeWithLinkGuardMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      node: // value for 'node'
 *      linkedAction: // value for 'linkedAction'
 *   },
 * });
 */
export function useDeleteNodeWithLinkGuardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNodeWithLinkGuardMutation, DeleteNodeWithLinkGuardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNodeWithLinkGuardMutation, DeleteNodeWithLinkGuardMutationVariables>(DeleteNodeWithLinkGuardDocument, options);
      }
export type DeleteNodeWithLinkGuardMutationHookResult = ReturnType<typeof useDeleteNodeWithLinkGuardMutation>;
export type DeleteNodeWithLinkGuardMutationResult = Apollo.MutationResult<DeleteNodeWithLinkGuardMutation>;
export type DeleteNodeWithLinkGuardMutationOptions = Apollo.BaseMutationOptions<DeleteNodeWithLinkGuardMutation, DeleteNodeWithLinkGuardMutationVariables>;
export const DeleteHierarchyWithLinkGuardDocument = gql`
    mutation DeleteHierarchyWithLinkGuard($aggregateId: String!, $linkedAction: LinkedNodeDeleteAction) {
  deleteHierarchy(aggregateId: $aggregateId, linkedAction: $linkedAction) {
    code
    message
    success
    choiceRequired
    linkedNodesTotal
    deletedNodesTotal
    linkedNodeGroups {
      hierarchyId
      hierarchyCode
      objectSchemaCode
      totalCount
      items {
        nodeId
        code
        listName
        parent
        hierarchyId
        hierarchyCode
        linkedByFields
      }
    }
  }
}
    `;
export type DeleteHierarchyWithLinkGuardMutationFn = Apollo.MutationFunction<DeleteHierarchyWithLinkGuardMutation, DeleteHierarchyWithLinkGuardMutationVariables>;

/**
 * __useDeleteHierarchyWithLinkGuardMutation__
 *
 * To run a mutation, you first call `useDeleteHierarchyWithLinkGuardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHierarchyWithLinkGuardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHierarchyWithLinkGuardMutation, { data, loading, error }] = useDeleteHierarchyWithLinkGuardMutation({
 *   variables: {
 *      aggregateId: // value for 'aggregateId'
 *      linkedAction: // value for 'linkedAction'
 *   },
 * });
 */
export function useDeleteHierarchyWithLinkGuardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHierarchyWithLinkGuardMutation, DeleteHierarchyWithLinkGuardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHierarchyWithLinkGuardMutation, DeleteHierarchyWithLinkGuardMutationVariables>(DeleteHierarchyWithLinkGuardDocument, options);
      }
export type DeleteHierarchyWithLinkGuardMutationHookResult = ReturnType<typeof useDeleteHierarchyWithLinkGuardMutation>;
export type DeleteHierarchyWithLinkGuardMutationResult = Apollo.MutationResult<DeleteHierarchyWithLinkGuardMutation>;
export type DeleteHierarchyWithLinkGuardMutationOptions = Apollo.BaseMutationOptions<DeleteHierarchyWithLinkGuardMutation, DeleteHierarchyWithLinkGuardMutationVariables>;
export const LinkedNodesForDeleteDocument = gql`
    query LinkedNodesForDelete($hierarchyId: String!, $nodeId: String!, $linkingHierarchyId: String, $limit: Int, $offset: Int) {
  getLinkedNodesForDelete(
    hierarchyId: $hierarchyId
    nodeId: $nodeId
    linkingHierarchyId: $linkingHierarchyId
    limit: $limit
    offset: $offset
  ) {
    total
    groups {
      hierarchyId
      hierarchyCode
      objectSchemaCode
      totalCount
      items {
        nodeId
        code
        listName
        parent
        hierarchyId
        hierarchyCode
        linkedByFields
      }
    }
  }
}
    `;

/**
 * __useLinkedNodesForDeleteQuery__
 *
 * To run a query within a React component, call `useLinkedNodesForDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedNodesForDeleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedNodesForDeleteQuery({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *      linkingHierarchyId: // value for 'linkingHierarchyId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLinkedNodesForDeleteQuery(baseOptions: Apollo.QueryHookOptions<LinkedNodesForDeleteQuery, LinkedNodesForDeleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedNodesForDeleteQuery, LinkedNodesForDeleteQueryVariables>(LinkedNodesForDeleteDocument, options);
      }
export function useLinkedNodesForDeleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedNodesForDeleteQuery, LinkedNodesForDeleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedNodesForDeleteQuery, LinkedNodesForDeleteQueryVariables>(LinkedNodesForDeleteDocument, options);
        }
export type LinkedNodesForDeleteQueryHookResult = ReturnType<typeof useLinkedNodesForDeleteQuery>;
export type LinkedNodesForDeleteLazyQueryHookResult = ReturnType<typeof useLinkedNodesForDeleteLazyQuery>;
export type LinkedNodesForDeleteQueryResult = Apollo.QueryResult<LinkedNodesForDeleteQuery, LinkedNodesForDeleteQueryVariables>;
export const CascadeDeletePreviewDocument = gql`
    query CascadeDeletePreview($hierarchyId: String!, $nodeId: String!, $linkingHierarchyId: String, $limit: Int, $offset: Int) {
  getCascadeDeletePreview(
    hierarchyId: $hierarchyId
    nodeId: $nodeId
    linkingHierarchyId: $linkingHierarchyId
    limit: $limit
    offset: $offset
  ) {
    total
    capExceeded
    lockedNodes {
      hierarchyId
      nodeId
      code
      message
    }
    groups {
      hierarchyId
      hierarchyCode
      objectSchemaCode
      totalCount
      items {
        nodeId
        code
        listName
        parent
        hierarchyId
        hierarchyCode
        reason
        viaCode
      }
    }
  }
}
    `;

/**
 * __useCascadeDeletePreviewQuery__
 *
 * To run a query within a React component, call `useCascadeDeletePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCascadeDeletePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCascadeDeletePreviewQuery({
 *   variables: {
 *      hierarchyId: // value for 'hierarchyId'
 *      nodeId: // value for 'nodeId'
 *      linkingHierarchyId: // value for 'linkingHierarchyId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useCascadeDeletePreviewQuery(baseOptions: Apollo.QueryHookOptions<CascadeDeletePreviewQuery, CascadeDeletePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CascadeDeletePreviewQuery, CascadeDeletePreviewQueryVariables>(CascadeDeletePreviewDocument, options);
      }
export function useCascadeDeletePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CascadeDeletePreviewQuery, CascadeDeletePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CascadeDeletePreviewQuery, CascadeDeletePreviewQueryVariables>(CascadeDeletePreviewDocument, options);
        }
export type CascadeDeletePreviewQueryHookResult = ReturnType<typeof useCascadeDeletePreviewQuery>;
export type CascadeDeletePreviewLazyQueryHookResult = ReturnType<typeof useCascadeDeletePreviewLazyQuery>;
export type CascadeDeletePreviewQueryResult = Apollo.QueryResult<CascadeDeletePreviewQuery, CascadeDeletePreviewQueryVariables>;